import { render, staticRenderFns } from "./InternationalRelocation.vue?vue&type=template&id=411778c1"
import script from "./InternationalRelocation.vue?vue&type=script&lang=js"
export * from "./InternationalRelocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports